import * as Marionette from "backbone.marionette";


export function repair() {
    Marionette.Renderer.render = function(template, data) {
        if(!template) {
            throw new (<any>Marionette).Error({
                name: "TemplateNotFoundError",
                message: "Cannot render the template since it is not defined."
            });
        }
        try {
            return template.render(data);
        }
        catch(e) {
            throw new (<any>Marionette).Error({
                name: "TemplateRenderError",
                message: e.message
            });
        }
    };
}



// WEBPACK FOOTER //
// ./@modules/utils/repair-renderer.ts